(() => {
  const normalizeQuantity = (value, min = 0, max = 99) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return min;
    return Math.min(max, Math.max(min, Math.trunc(numeric)));
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quantity]');
    if (!trigger) return;
    const wrapper = trigger.closest('.ww-quantity');
    const input = wrapper?.querySelector('input');
    if (!input) return;
    input.dataset.previousValue = input.value;
    const min = Number(input.min || 0);
    const max = Number(input.max || 99);
    const next = normalizeQuantity(Number(input.value || 0) + (trigger.dataset.quantity === 'plus' ? 1 : -1), min, max);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  const cartForm = document.querySelector('[data-cart-form]');
  const cartItems = document.querySelector('.ww-cart__items');
  const cartScrollCurrent = document.querySelector('[data-cart-scroll-current]');
  const cartScrollProgress = document.querySelector('[data-cart-scroll-progress]');
  const cartScrollTotal = document.querySelector('[data-cart-scroll-total]');
  const cartSubtotal = document.querySelector('[data-cart-subtotal]');
  const cartTotalCount = document.querySelector('[data-cart-total-count]');
  const gsap = window.gsap;
  let updateCartScroll = () => {};

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-product-gallery-track]');
    if (!track) return;

    const slidesBeforeDeduplication = [...track.querySelectorAll('[data-product-gallery-slide], .ww-product__media')];
    const seenSources = new Set();
    slidesBeforeDeduplication.forEach((slide) => {
      const image = slide.querySelector('img');
      const source = image?.getAttribute('src') || image?.currentSrc;
      if (!source) return;
      let key = source;
      try {
        const url = new URL(source, document.baseURI);
        key = `${url.origin}${url.pathname}`;
      } catch (error) {
        key = source.split(/[?#]/)[0];
      }
      if (seenSources.has(key)) slide.remove();
      else seenSources.add(key);
    });

    const slides = [...track.querySelectorAll('[data-product-gallery-slide], .ww-product__media')];
    const previous = gallery.querySelector('[data-product-gallery-prev]');
    const next = gallery.querySelector('[data-product-gallery-next]');
    const position = gallery.querySelector('[data-product-gallery-position]');
    const current = gallery.querySelector('[data-product-gallery-current]');
    const total = gallery.querySelector('[data-product-gallery-total]');
    if (!slides.length) return;

    let currentIndex = 0;
    let scrollFrame = 0;
    const formatPosition = (value) => String(value).padStart(2, '0');
    const updatePosition = () => {
      scrollFrame = 0;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;
      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      currentIndex = closestIndex;
      const humanCurrent = currentIndex + 1;
      const humanTotal = slides.length;
      if (current) current.textContent = formatPosition(humanCurrent);
      if (total) total.textContent = formatPosition(humanTotal);
      if (position) position.setAttribute('aria-label', `Image ${humanCurrent} of ${humanTotal}`);
      if (previous) previous.disabled = currentIndex === 0;
      if (next) next.disabled = currentIndex === slides.length - 1;
    };
    const requestPositionUpdate = () => {
      if (!scrollFrame) scrollFrame = window.requestAnimationFrame(updatePosition);
    };
    const goTo = (index) => {
      const targetIndex = Math.min(slides.length - 1, Math.max(0, index));
      const left = slides[targetIndex].offsetLeft;
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      if (typeof track.scrollTo === 'function') track.scrollTo({ left, behavior });
      else track.scrollLeft = left;
      requestPositionUpdate();
    };

    track.addEventListener('scroll', requestPositionUpdate, { passive: true });
    previous?.addEventListener('click', () => goTo(currentIndex - 1));
    next?.addEventListener('click', () => goTo(currentIndex + 1));
    gallery.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    window.addEventListener('resize', requestPositionUpdate, { passive: true });
    updatePosition();
  });

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'en';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: cents % 100 ? 2 : 0,
      maximumFractionDigits: 2
    }).format(cents / 100);
  };

  const pulse = (elements) => {
    const targets = elements.filter(Boolean);
    if (!gsap || !targets.length) return;
    gsap.fromTo(targets, { scale: .94, autoAlpha: .55 }, { scale: 1, autoAlpha: 1, duration: .34, ease: 'circ.out', clearProps: 'transform,opacity,visibility' });
  };

  const animateCartBubble = (sourceButton, quantity) => {
    if (!sourceButton || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const target = document.querySelector('[data-cart-target]')
      || document.querySelector('[data-global-cart-count]')?.closest('a')
      || document.querySelector('.ww-header a[href*="cart"]');
    if (!target) return;
    const sourceRect = sourceButton.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();
    if (!sourceRect.width || !sourceRect.height || !targetRect.width || !targetRect.height) return;
    const deltaX = targetRect.left + targetRect.width / 2 - (sourceRect.left + sourceRect.width / 2);
    const deltaY = targetRect.top + targetRect.height / 2 - (sourceRect.top + sourceRect.height / 2);

    const flyer = document.createElement('span');
    flyer.className = 'ww-cart-flyer';
    flyer.textContent = `+${quantity}`;
    flyer.setAttribute('aria-hidden', 'true');
    flyer.style.left = `${sourceRect.left + sourceRect.width / 2 - 21}px`;
    flyer.style.top = `${sourceRect.top + sourceRect.height / 2 - 21}px`;
    document.body.appendChild(flyer);

    flyer.classList.add('is-flying');
    const arc = -Math.min(150, Math.max(50, Math.hypot(deltaX, deltaY) * .12));
    const controlX = deltaX * .45;
    const controlY = deltaY * .45 + arc;
    const startedAt = performance.now();
    const duration = 920;
    const easeOutCubic = (value) => 1 - Math.pow(1 - value, 3);
    const fly = (now) => {
      if (!flyer.isConnected) return;
      const progress = Math.min(1, (now - startedAt) / duration);
      const t = easeOutCubic(progress);
      const inverse = 1 - t;
      const x = (2 * inverse * t * controlX) + (t * t * deltaX);
      const y = (2 * inverse * t * controlY) + (t * t * deltaY);
      const scale = progress < .2 ? .58 + (progress / .2) * .62 : 1.2 - ((progress - .2) / .8) * .9;
      const opacity = progress < .12 ? progress / .12 : progress > .72 ? 1 - ((progress - .72) / .28) : 1;
      flyer.style.opacity = String(Math.max(0, opacity));
      flyer.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${Math.max(.3, scale)})`;
      if (progress < 1) window.requestAnimationFrame(fly);
      else {
        flyer.remove();
        target.classList.remove('is-cart-targeting');
        void target.offsetWidth;
        target.classList.add('is-cart-targeting');
        window.setTimeout(() => target.classList.remove('is-cart-targeting'), 420);
      }
    };
    window.requestAnimationFrame(fly);
  };

  const syncCartTotals = ({ itemCount, totalPrice }) => {
    document.querySelectorAll('[data-global-cart-count], [data-cart-count]').forEach((count) => { count.textContent = itemCount; });
    document.querySelectorAll('[data-cart-target]').forEach((target) => target.classList.toggle('has-items', itemCount > 0));
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(totalPrice);
    if (cartTotalCount) cartTotalCount.textContent = `${itemCount} ${itemCount === 1 ? 'Item' : 'Items'} Total`;
    if (cartScrollTotal) cartScrollTotal.textContent = String(document.querySelectorAll('.ww-cart-item').length).padStart(2, '0');
    pulse([cartSubtotal, cartTotalCount]);
  };

  const animateCartRemoval = (card) => new Promise((resolve) => {
    const before = new Map([...document.querySelectorAll('.ww-cart-item')].map((item) => [item, item.getBoundingClientRect()]));
    const remove = () => {
      card.remove();
      requestAnimationFrame(() => {
        before.forEach((oldBounds, item) => {
          if (!item.isConnected) return;
          const nextBounds = item.getBoundingClientRect();
          const x = oldBounds.left - nextBounds.left;
          const y = oldBounds.top - nextBounds.top;
          if (gsap && (x || y)) gsap.fromTo(item, { x, y }, { x: 0, y: 0, duration: .5, ease: 'circ.inOut', clearProps: 'transform' });
        });
        updateCartScroll();
        resolve();
      });
    };
    if (gsap) gsap.to(card, { autoAlpha: 0, scale: .7, duration: .32, ease: 'circ.in', onComplete: remove });
    else remove();
  });

  const previewCartState = () => {
    let itemCount = 0;
    let totalPrice = 0;
    document.querySelectorAll('.ww-cart-item').forEach((card) => {
      const quantity = Number(card.querySelector('.ww-quantity input')?.value || 0);
      const unitPrice = Number(card.dataset.unitPrice || 0);
      itemCount += quantity;
      totalPrice += quantity * unitPrice;
      const price = card.querySelector('[data-cart-line-price]');
      if (price) price.textContent = formatMoney(quantity * unitPrice);
    });
    return { itemCount, totalPrice };
  };

  const updateCartLine = async (card, quantity, input) => {
    if (!card || card.classList.contains('is-updating')) return;
    const previous = Number(input?.dataset.previousValue ?? input?.dataset.lastValue ?? input?.value ?? 0);
    card.classList.add('is-updating');
    card.querySelectorAll('button, input').forEach((control) => { control.disabled = true; });
    try {
      let state;
      let linePrice = quantity * Number(card.dataset.unitPrice || 0);
      if (cartForm?.hasAttribute('data-preview-cart')) {
        if (input) input.value = quantity;
        state = previewCartState();
      } else {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: card.dataset.cartLine, quantity })
        });
        if (!response.ok) throw new Error('Cart update failed');
        const cart = await response.json();
        const line = cart.items.find((item) => item.key === card.dataset.cartLine);
        linePrice = line?.final_line_price || 0;
        state = { itemCount: cart.item_count, totalPrice: cart.total_price };
      }

      if (quantity === 0) await animateCartRemoval(card);
      else {
        const price = card.querySelector('[data-cart-line-price]');
        if (price) price.textContent = formatMoney(linePrice);
        if (input) input.dataset.lastValue = String(quantity);
        pulse([price]);
      }
      syncCartTotals(state);
      if (!document.querySelector('.ww-cart-item') && !cartForm?.hasAttribute('data-preview-cart')) window.location.reload();
    } catch (error) {
      if (input) input.value = previous;
      card.classList.add('has-error');
      window.setTimeout(() => card.classList.remove('has-error'), 900);
      console.error(error);
    } finally {
      if (card.isConnected) {
        card.classList.remove('is-updating');
        card.querySelectorAll('button, input').forEach((control) => { control.disabled = false; });
      }
    }
  };

  if (cartItems) {
    let cartScrollFrame = 0;
    updateCartScroll = () => {
      cartScrollFrame = 0;
      const maxScroll = Math.max(1, cartItems.scrollWidth - cartItems.clientWidth);
      const cards = [...cartItems.querySelectorAll('.ww-cart-item')];
      const progress = Math.min(1, cartItems.scrollLeft / maxScroll);
      const current = Math.min(cards.length, Math.max(1, Math.round(progress * Math.max(0, cards.length - 1)) + 1));
      if (cartScrollCurrent) cartScrollCurrent.textContent = String(current).padStart(2, '0');
      if (cartScrollProgress) cartScrollProgress.style.transform = `scaleX(${progress})`;
    };
    const requestCartScrollUpdate = () => {
      if (!cartScrollFrame) cartScrollFrame = requestAnimationFrame(updateCartScroll);
    };
    requestAnimationFrame(() => {
      cartItems.scrollLeft = 0;
      updateCartScroll();
    });
    cartItems.addEventListener('scroll', requestCartScrollUpdate, { passive: true });
    cartItems.addEventListener('wheel', (event) => {
      if (window.innerWidth <= 600 || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
      const maxScroll = cartItems.scrollWidth - cartItems.clientWidth;
      if (maxScroll <= 0) return;
      event.preventDefault();
      cartItems.scrollLeft += event.deltaY;
    }, { passive: false });
  }
  cartForm?.querySelectorAll('.ww-quantity input').forEach((input) => {
    const quantity = normalizeQuantity(input.value, Number(input.min || 0), Number(input.max || 99));
    input.value = String(quantity);
    input.dataset.lastValue = input.value;
  });
  const commitCartQuantity = (input) => {
    if (!input?.matches('.ww-quantity input')) return;
    const quantity = normalizeQuantity(input.value, Number(input.min || 0), Number(input.max || 99));
    input.value = String(quantity);
    if (input.dataset.lastValue === String(quantity)) return;
    updateCartLine(input.closest('.ww-cart-item'), quantity, input);
  };
  cartForm?.addEventListener('change', (event) => {
    commitCartQuantity(event.target);
  });
  cartForm?.addEventListener('focusout', (event) => {
    commitCartQuantity(event.target);
  });

  document.addEventListener('click', (event) => {
    const remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    const card = remove.closest('.ww-cart-item');
    const input = card?.querySelector('.ww-quantity input');
    if (input) input.dataset.previousValue = input.value;
    updateCartLine(card, 0, input);
  });

  document.querySelector('[data-cart-note-toggle]')?.addEventListener('click', (event) => {
    const panel = document.querySelector('[data-cart-note]');
    if (!panel) return;
    const willOpen = panel.hidden;
    event.currentTarget.setAttribute('aria-expanded', String(willOpen));
    event.currentTarget.querySelector('span').textContent = willOpen ? 'Close Note' : 'Add Note';
    cartForm?.classList.toggle('is-note-open', willOpen);
    if (!gsap) {
      panel.hidden = !willOpen;
      if (willOpen) panel.querySelector('textarea')?.focus({ preventScroll: true });
      return;
    }
    gsap.killTweensOf(panel);
    if (willOpen) {
      panel.hidden = false;
      gsap.fromTo(panel, { height: 0, autoAlpha: 0 }, {
        height: 'auto', autoAlpha: 1, duration: .42, ease: 'circ.inOut',
        onComplete: () => panel.querySelector('textarea')?.focus({ preventScroll: true })
      });
    } else {
      gsap.to(panel, { height: 0, autoAlpha: 0, duration: .36, ease: 'circ.inOut', onComplete: () => { panel.hidden = true; } });
    }
  });

  document.querySelectorAll('[data-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const scope = select.closest('.ww-product__details');
      const price = scope?.querySelector('[data-product-price]');
      const add = scope?.querySelector('[data-product-add]');
      const label = add?.querySelector('[data-product-add-label]');
      const available = option.dataset.available === 'true';
      if (price) price.textContent = option.dataset.price || '';
      if (add) {
        add.disabled = !available;
        if (label) label.textContent = available ? 'Add to cart' : 'Sold out';
        else add.firstChild.textContent = available ? 'Add to cart ' : 'Sold out ';
      }
    });
  });

  const updateGlobalCartCount = (itemCount) => {
    document.querySelectorAll('[data-global-cart-count], [data-cart-count]').forEach((count) => { count.textContent = itemCount; });
    document.querySelectorAll('[data-cart-target]').forEach((target) => target.classList.toggle('has-items', itemCount > 0));
  };

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const input = form.querySelector('[data-product-quantity-input]');
    const minus = form.querySelector('[data-product-quantity="minus"]');
    const plus = form.querySelector('[data-product-quantity="plus"]');
    const add = form.querySelector('[data-product-add]');
    const label = add?.querySelector('[data-product-add-label]');
    const status = form.querySelector('[data-product-status]');
    if (!input || !add) return;

    const min = Math.max(1, Number(input.min || 1));
    const max = Number(input.max || 99);
    const syncQuantityControls = () => {
      const value = normalizeQuantity(input.value, min, max);
      input.value = value;
      if (minus) minus.disabled = value <= min;
      if (plus) plus.disabled = value >= max;
      return value;
    };
    const setQuantity = (value) => {
      input.value = normalizeQuantity(value, min, max);
      syncQuantityControls();
    };

    minus?.addEventListener('click', () => setQuantity(Number(input.value) - 1));
    plus?.addEventListener('click', () => setQuantity(Number(input.value) + 1));
    input.addEventListener('change', syncQuantityControls);
    syncQuantityControls();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (form.classList.contains('is-adding') || add.disabled) return;
      const quantity = syncQuantityControls();
      const originalLabel = label?.textContent || 'Add to cart';
      animateCartBubble(add, quantity);
      form.classList.add('is-adding');
      add.disabled = true;
      if (label) label.textContent = 'Adding…';
      if (status) status.textContent = 'Adding to cart';

      try {
        if (form.hasAttribute('data-preview-product')) {
          const currentCount = Number(document.body.dataset.previewCartCount || document.querySelector('[data-global-cart-count]')?.textContent || 0);
          const nextCount = currentCount + quantity;
          document.body.dataset.previewCartCount = String(nextCount);
          updateGlobalCartCount(nextCount);
        } else {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('Product could not be added');
          const currentCount = Number(document.querySelector('[data-global-cart-count]')?.textContent || 0);
          updateGlobalCartCount(currentCount + quantity);
        }
        if (label) label.textContent = 'Added';
        add.classList.add('is-added');
        if (status) status.textContent = `${quantity} ${quantity === 1 ? 'item' : 'items'} added to cart`;
        window.setTimeout(() => {
          if (!add.isConnected) return;
          if (label) label.textContent = originalLabel;
          add.classList.remove('is-added');
          add.disabled = false;
          form.classList.remove('is-adding');
          if (status) status.textContent = '';
        }, 1600);
      } catch (error) {
        if (label) label.textContent = 'Try again';
        if (status) status.textContent = 'Could not add to cart. Please try again.';
        add.disabled = false;
        form.classList.remove('is-adding');
        console.error(error);
      }
    });
  });

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-analytics-event]');
    if (!target) return;
    const detail = {
      event: target.dataset.analyticsEvent,
      href: target.href || '',
      productHandle: target.closest('[data-handle]')?.dataset.handle || document.body.dataset.productHandle || ''
    };
    window.dispatchEvent(new CustomEvent('whywear:analytics', { detail }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: 'whywear_event', ...detail });
  });
})();
